/**
 * Copies text to the clipboard.
 *
 * Returns `true` when the write succeeds and `false` when the Clipboard API is
 * unavailable or rejects (e.g. missing permissions or an insecure context), so
 * callers can decide whether to surface feedback.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  if (!text) return false

  try {
    if (typeof navigator === 'undefined' || !navigator.clipboard) {
      return false
    }
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}
